import { inboundShipmentIdFormat } from "@redotech/redo-ids/ids";
import * as z from "zod";

export const bulkDeleteShipments = {
  name: "bulkDeleteShipments" as const,
  input: z.object({
    inboundShipmentIds: z.array(inboundShipmentIdFormat.schema),
  }),
  output: z.object({ success: z.boolean() }),
};
